
import Vue from 'vue';
export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true,
    },
    dimensions: {
      type: String,
      required: true,
    },
  },
});
